import { render, staticRenderFns } from "./PhaseTemplate.vue?vue&type=template&id=16583b7d"
import script from "./PhaseTemplate.vue?vue&type=script&lang=js"
export * from "./PhaseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports